import { ParsedPreset, Prettify } from '@aibees/shared/definition';
import { SearchBrowseParams } from './search';

export enum ElephantPresetType {
  COMPANY_RECENT_SEARCH = 'COMPANY_RECENT_SEARCH',
  PERSON_RECENT_SEARCH = 'PERSON_RECENT_SEARCH',

  COMPANY_SAVED_SEARCH = 'COMPANY_SAVED_SEARCH',
  PEOPLE_SAVED_SEARCH = 'PEOPLE_SAVED_SEARCH',

  RECENT_FILTER = 'RECENT_FILTER',

  JOB_ROLE_MATRIX = 'JOB_ROLE_MATRIX',
  JOB_ROLE_MATRIX_ORDER = 'JRM_ORDER',
  BUYING_TEAM_MATRIX = 'BUYING_TEAM_MATRIX',
  BUYING_TEAM_MATRIX_ORDER = 'BTM_ORDER',
  DEFAULT_BUYING_TEAM_MATRIX_REMOVE = 'DEFAULT_BTM_REMOVE',

  COMPANY_SEARCH_TABLE_LAYOUT = 'COMPANY_SEARCH_TABLE_LAYOUT_V4',
  PEOPLE_SEARCH_TABLE_LAYOUT = 'PEOPLE_SEARCH_TABLE_LAYOUT_V4',
  COMPANY_EMPLOYEES_SEARCH_TABLE_LAYOUT = 'COMPANY_EMPLOYEES_SEARCH_TABLE_LAYOUT_V4',

  ACCOUNT_USERS_TABLE_LAYOUT = 'ACCOUNT_USERS_TABLE_LAYOUT',

  EMPLOYEES_TRENDS_DEPARTMENTS = 'EMPLOYEES_TRENDS_DEPARTMENTS_V5',

  COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS = 'COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS_V27',
  PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS = 'PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS_V27',
  INTEGRATION_EXPORT_SETTINGS_COLUMNS = 'INTEGRATION_EXPORT_SETTINGS_COLUMNS_V3',

  COMPANY_SIMILARITY_RECENT_SEARCH = 'COMPANY_SIMILARITY_RECENT_SEARCH_V2',

  LIST_COMPANY = 'LIST_COMPANY',
  LIST_PEOPLE = 'LIST_PEOPLE',
  LABEL_COMPANY = 'LABEL_COMPANY',
  LABEL_PEOPLE = 'LABEL_PEOPLE',

  FAVORITE_TECHNOLOGIES = 'FAVORITE_TECHNOLOGIES',
  SHARE_SEARCH = 'SHARE_SEARCH',
}

export type RecentSearch = ParsedPreset<SearchBrowseParams>;

export type SavedSearch = Prettify<ParsedPreset<SearchBrowseParams>>;
